// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"62977478","15":"0ed4711c","306":"57196089","354":"40054697","761":"ee48d13a","787":"95a2f104","792":"6febf3d1","879":"1ed32ff6"}[chunkId] + ".chunk.js";
};